PJQ.views.projects.LocationManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-management'),
        subTemplates: {
            tier: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-tier'),
            location: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-item'),
            editLocation: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'location-edit')
        }
    },
    events: {
        'click .location:not(.editing)': 'locationClicked',
        'click .btn-add-location': 'addLocationClicked',
        'keyup .input-location-name': 'locationNameChanged',
        'click .btn-edit-location': 'editLocationClicked',
        'click .btn-delete-location': 'deleteLocationClicked',
        'click .btn-cancel-edit': 'endLocationEdit',
        'click .btn-save-location': 'saveLocationClicked'
    },
    beforeFirstRender: function () {
        this.options.project.fetchLocations(_.bind(function (locations) {
            this.collection = locations;
            this.render();
        }, this))
    },
    afterRender: function () {
        if (this.collection == null) {
            return;
        }

        this.$el.on('click', function () {
            $(this).find('.dropdown-menu').hide();
        });

        let $tiers = this.$('.location-tiers');
        $tiers.on('click', '.location-dropdown-toggle', (function (e) {
            $(this).next('.dropdown-menu').toggle();
            e.stopPropagation();
        }));

        this.renderTiers();
    },
    locationNameChanged: function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.saveLocationClicked(e);
        }
    },
    addLocationClicked: function (e) {
        this.renderLocationEdit($(e.currentTarget));
    },
    editLocationClicked: function (e) {
        e.stopPropagation();

        let $location = $(e.currentTarget).closest('.location'),
            id = $location.data('id'),
            location = this.collection.get(id);

        this.endLocationEdit();
        this.editLocation = location;
        if (location != null) {
            $location.addClass('editing');
            this.renderLocationEdit($location, location);
        }
    },
    renderLocationEdit: function ($location, location) {
        this.renderSubTemplate(false, this.options.subTemplates.editLocation, $location, {
            location: location
        }, _.bind(function () {
            this.$('.input-location-name').focus().select();
        }, this));
    },
    endLocationEdit: function (e) {
        if (e) {
            e.stopPropagation();

            let $add = $(e.currentTarget).closest('.btn-add-location'),
                parentId = $add.length > 0 ? $add.data('parentId') : null;
            if (parentId != null) {
                this.renderTiers();
                return;
            }
        }

        if (this.editLocation != null) {
            let $location = this.$('.location[data-id="' + this.editLocation.id + '"]');
            if ($location.length > 0) {
                $location.replaceWith(this.renderLocation(this.editLocation, this.getActiveLocations()).outerHTML());
            }
            this.editLocation = null;
        }
    },
    saveLocationClicked: function (e) {
        e.stopPropagation();

        let saveLocation = null,
            name = $(e.currentTarget).parent().find('.input-location-name').val(),
            $add = $(e.currentTarget).closest('.btn-add-location'),
            parentId = $add.length > 0 ? $add.data('parentId') : null;
        if (parentId != null) {
            saveLocation = new PJQ.models.projects.Location({
                projectId: this.options.project.id,
                name: name,
                parentId: parentId > 0 ? parentId : null
            });
            this.collection.add(saveLocation);
            this.contextLocation = saveLocation;
        } else if (_.size(name) > 0) {
            this.editLocation.set('name', name);
            saveLocation = this.editLocation;
        }

        if (saveLocation != null) {
            saveLocation.save(null, {
                success: _.bind(function () {
                    //todo: notify saved, add loading maybe
                    this.renderTiers();
                }, this)
            });
        }
    },
    locationClicked: function (e) {
        let id = $(e.currentTarget).data('id');
        this.contextLocation = this.collection.get(id);
        this.renderTiers();
    },
    deleteLocationClicked: function (e) {
        e.stopPropagation();

        let id = $(e.currentTarget).closest('.location').data('id'),
            location = this.collection.get(id),
            children = this.collection.getChildren(location, true),
            fnDelete = _.bind(function () {
                location.destroy({
                    success: _.bind(function () {
                        this.collection.remove(_.union([location], children));
                        if (this.contextLocation != null && this.collection.get(this.contextLocation.id) == null) {
                            // the context location was deleted
                            // try to get the closest existing parent of it
                            let activeLocations = this.getActiveLocations().reverse(),
                                newContextLocation = null;
                            for (let i = 0; i < _.size(activeLocations); i++) {
                                if (activeLocations[i].id !== this.contextLocation.id) {
                                    newContextLocation = activeLocations[i];
                                    break;
                                }
                            }
                            this.contextLocation = newContextLocation;
                        }
                        this.renderTiers();
                    }, this)
                });
            }, this)

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this location?  All of it's child locations will also be deleted.",
            onDelete: _.bind(function () {
                fnDelete();
            }, this)
        });
    },
    getActiveLocations: function () {
        if (this.contextLocation == null) {
            return [];
        }

        let result = this.collection.getParents(this.contextLocation);
        result.push(this.contextLocation);
        return result;
    },
    renderTiers: function () {
        this.editLocation = null;

        this.$tiers = this.$('.location-tiers');
        this.$tiers.empty();

        let nextTierLocations,
            activeLocations = this.getActiveLocations(),
            ctActive = _.size(activeLocations);
        if (this.contextLocation != null) {
            for (let i = 0; i < ctActive; i++) {
                this.renderTier(i + 1, this.collection.getSiblings(activeLocations[i]), activeLocations, i > 0 ? activeLocations[i - 1] : null);
            }

            nextTierLocations = this.collection.getChildren(this.contextLocation);
        } else {
            nextTierLocations = this.collection.getRootLocations();
        }
        this.renderTier(ctActive + 1, nextTierLocations, activeLocations, ctActive > 0 ? activeLocations[ctActive - 1] : null);
    },
    renderTier: function (tierNumber, locations, activeLocations, activeParent) {
        this.renderSubTemplate(true, this.options.subTemplates.tier, this.$tiers, {
            tierNumber: tierNumber,
            locations: locations,
            activeLocations: activeLocations,
            activeParent: activeParent,
            renderLocation: _.bind(this.renderLocation, this)
        });
    },
    renderLocation: function (location, activeLocations) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.location, {
            activeIds: activeLocations ? _.map(activeLocations, function (location) {
                return location.id;
            }) : [],
            location: location
        });
    }
});

PJQ.models.projects.Location = PJQ.models.BaseModel.extend({
    idAttribute: "id",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.get('projectId')
            },
            {
                endpoint: 'locations',
                value: this.id
            }
        ])
    }
});

PJQ.collections.projects.Locations = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.projects.Location,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.project.id
            },
            {
                endpoint: 'locations'
            }
        ]);
    },
    getRootLocations: function () {
        return _.filter(this.models, function (location) {
            return !(location.get("parentId") > 0);
        });
    },
    getChildren: function (location, recursive = false) {
        if (recursive) {
            let fnGetChildren = _.bind(function (locations, result) {
                if (result == null) {
                    result = [];
                }

                if (_.size(locations) === 0) {
                    return result;
                }

                let children = [];
                _.each(locations, function (location) {
                    children.push(...this.where({parentId: location.id}));
                }, this)
                result.push(...children);

                return fnGetChildren(children, result);
            }, this)
            return fnGetChildren([location]);
        }

        return this.where({parentId: location.id});
    },
    getSiblings: function (location) {
        let pId = location.get('parentId');
        if (pId > 0) {
            return this.where({parentId: pId});
        }
        return this.getRootLocations();
    },
    getParents: function (location) {
        let fnGetParent = _.bind(function (location, result) {
            if (result == null) {
                result = [];
            }

            let pId = location.get('parentId');
            if (!(pId > 0)) {
                return result;
            }
            let parent = this.get(pId);
            if (parent == null) {
                return result;
            }
            result.push(parent);
            return fnGetParent(parent, result);
        }, this)
        return fnGetParent(location).reverse();
    },
    getPickerArray: function () {
        let result = [],
            getChildrenNames = _.bind(function (location, parentName) {
                result.push({
                    id: location.id,
                    name: parentName
                });
                _.each(_.sortBy(this.where({parentId: location.id}), (location) => { return location.get('name') }), function (child) {
                    let newParentName = parentName + ' > ' + child.get('name');
                    getChildrenNames(child, newParentName);
                });
            }, this)
        _.each(_.sortBy(this.where({parentId: null}), (location) => { return location.get('name') }), function (rootParent) {
            getChildrenNames(rootParent, rootParent.get('name'));
        });
        return result;
    },
    getFullName: function (location) {
        let parents = this.getParents(location),
            result = '';
        _.each(parents, function (parent) {
            result += parent.get('name') + ' > ';
        });
        result += location.get('name');
        return result;
    }
});